'use client';

import { useEffect } from 'react';
import Link from 'next/link';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <div className="max-w-md text-center">
        <h1 className="text-9xl font-bold text-red-600">500</h1>
        <p className="mt-4 text-2xl font-semibold text-gray-900">
          Something went wrong!
        </p>
        <p className="mt-2 text-gray-600">
          An unexpected error occurred. Please try again later.
        </p>
        <button
          onClick={() => reset()}
          className="mt-6 inline-flex items-center px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors"
        >
          Try again
        </button>
        <Link 
          href="/" 
          className="mt-4 inline-flex items-center px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
        >
          Go back home
        </Link>
      </div>
    </div>
  );
}
